/*import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  Box,
  Tabs,
  Tab,
  IconButton,
  Grid2
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import DecoSelect from "./DecoSelect";
import {
  racktypeoptions,
  rackcodeoptions,
  rackcolouroptions,
  racksizeoptions,
} from "../constants/closetOptions";

export default function RackFormTabs({ initialData = [], onChange }) {
  const [rows, setRows] = useState(Array.isArray(initialData) ? initialData : []);
  const [activeTab, setActiveTab] = useState(0);

  // Track last action: "add" | "remove"
  const lastAction = useRef(null);
  const removedIndex = useRef(null);

  useEffect(() => {
    if (typeof onChange === "function") onChange(rows);
  }, [rows, onChange]);

  // ✅ Manage tab switching reliably based on action
  useEffect(() => {
    if (lastAction.current === "add") {
      setActiveTab(rows.length - 1);
      lastAction.current = null;
    } else if (lastAction.current === "remove") {
      if (rows.length === 0) setActiveTab(0);
      else if (removedIndex.current >= rows.length) setActiveTab(rows.length - 1);
      else setActiveTab(removedIndex.current);
      lastAction.current = null;
      removedIndex.current = null;
    } else if (activeTab >= rows.length && rows.length > 0) {
      // Edge case fallback
      setActiveTab(rows.length - 1);
    }
  }, [rows, activeTab]);

  const handleChange = (index, key, value) => {
    setRows((prevRows) => {
      const updated = [...prevRows];
      updated[index][key] = value;
      if (key === "racktype") {
        updated[index].rackcode = "";
        updated[index].rackcolour = "";
        updated[index].racksize = "";
      }
      return updated;
    });
  };

  const handleAddRow = () => {
    const newRow = { rackquantity: "", racktype: "", rackcode: "", rackcolour: "", racksize: "" };
    lastAction.current = "add";
    setRows((prev) => [...prev, newRow]);
  };

  const handleRemoveRow = (index) => {
    lastAction.current = "remove";
    removedIndex.current = index;
    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between" }}>
        <Button variant="contained" onClick={handleAddRow} sx={{ backgroundColor: "#bda485" }}>
          Add Rack
        </Button>
      </Box>

      {rows.length > 0 && (
        <>
          <Tabs
            value={activeTab}
            onChange={(_, newValue) => setActiveTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {rows.map((_, index) => (
              <Tab
                key={index}
                label={
                  <Box display="flex" alignItems="center" gap={1}>
                    Rack {index + 1}
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveRow(index);
                      }}
                    > x
                    </IconButton>
                  </Box>
                }
              />
            ))}
          </Tabs>

          {rows.map((row, index) => {
            if (index !== activeTab) return null;
            const { rackquantity, racktype, rackcode, rackcolour, racksize } = row;
            const codes = racktype ? rackcodeoptions[racktype] || [] : [];
            const colours = racktype ? rackcolouroptions[racktype] || [] : [];
            const sizes = racktype ? racksizeoptions[racktype] || [] : [];
            const rquantity = rackquantity;
            return (
              <Box key={index} sx={{ p: 2, border: "1px solid #ddd", mt: 2 }}>
                <Grid2 container spacing={2}>
                  <Grid2 item xs={6}>
                    <TextField
                                                               fullWidth
                                                               label="Rack Quantity"
                                                               type="number"
                                                               value={rackquantity || ""}
                                                               onChange={(e) => {
                                                                 const newValue = e.target.value;
                                                                 if (
                                                                   newValue === "" ||
                                                                   /^[1-9]\d*$/.test(newValue)
                                                                 ) {
                                                                   handleRackChange(
                                                                     index,
                                                                     "rackquantity",
                                                                     newValue
                                                                   );
                                                                 }
                                                               }}
                                                             />
                  </Grid2>
                  <Grid2 item xs={6}>
                    <Autocomplete
                      options={racktypeoptions}
                      value={racktypeoptions.includes(racktype) ? racktype : null}
                      onChange={(_, newValue) =>
                        handleChange(index, "racktype", newValue || "")
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Rack Type" />
                      )}
                    />
                  </Grid2>

                  {racktype && codes.length > 0 && (
                    <Grid2 item xs={6}>
                      <DecoSelect
                        label="Rack Code"
                        value={codes.includes(rackcode) ? rackcode : ""}
                        onChange={(e) =>
                          handleChange(index, "rackcode", e.target.value)
                        }
                        menuItems={codes}
                      />
                    </Grid2>
                  )}

                  {racktype && colours.length > 0 && (
                    <Grid2 item xs={6}>
                      <DecoSelect
                        label="Rack Colour"
                        value={colours.includes(rackcolour) ? rackcolour : ""}
                        onChange={(e) =>
                          handleChange(index, "rackcolour", e.target.value)
                        }
                        menuItems={colours}
                      />
                    </Grid2>
                  )}

                  {racktype && sizes.length > 0 && (
                    <Grid2 item xs={6}>
                      <DecoSelect
                        label="Rack Size"
                        value={sizes.includes(racksize) ? racksize : ""}
                        onChange={(e) =>
                          handleChange(index, "racksize", e.target.value)
                        }
                        menuItems={sizes}
                      />
                    </Grid2>
                  )}
                </Grid2>
              </Box>
            );
          })}
        </>
      )}
    </Box>
  );
}*/

import { Grid, TextField, Autocomplete } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import DecoSelect from "./DecoSelect";
import {
  racktypeoptions,
  rackcodeoptions,
  rackcolouroptions,
  racksizeoptions,
} from "../constants/closetOptions";

// The blank row shape for a new Rack tab. Exported so DynamicTabsForm's
// `createEmptyRow` can be defined right next to the fields it creates.
export const createEmptyRackRow = () => ({
  rackquantity: "",
  racktype: "",
  rackcode: "",
  rackcolour: "",
  racksize: "",
});

/**
 * Fields for a single Rack row. Rendered inside DynamicTabsForm's
 * per-tab content area via its `renderRow` prop.
 */
export default function RackRowFields({ row, index, onFieldChange, fieldErrors = {} }) {
  const { rackquantity, racktype, rackcode, rackcolour, racksize } = row;

  const codes = racktype ? rackcodeoptions[racktype] || [] : [];
  const colours = racktype ? rackcolouroptions[racktype] || [] : [];
  const sizes = racktype ? racksizeoptions[racktype] || [] : [];

  const hasError = (field) => !!fieldErrors[`${index}-${field}`];

  return (
    <>
      {/* Row 1: Quantity + Type */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Rack Quantity"
            type="text"
            value={rackquantity || ""}
            error={hasError("rackquantity")}
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue === "" || /^[1-9]\d*$/.test(newValue)) {
                onFieldChange(index, { rackquantity: newValue });
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            options={racktypeoptions}
            value={racktypeoptions.includes(racktype) ? racktype : null}
            onChange={(_, newValue) =>
              // Changing the type invalidates whatever code/colour/size was
              // picked for the previous type, so reset them atomically.
              onFieldChange(index, {
                racktype: newValue || "",
                rackcode: "",
                rackcolour: "",
                racksize: "",
              })
            }
            renderInput={(params) => (
              <TextField {...params} label="Rack Type" error={hasError("racktype")} />
            )}
          />
        </Grid>
      </Grid>

      {/* Row 2: Code + Colour */}
      {racktype && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
            {codes.length > 0 && (
              <Autocomplete
                options={codes}
                value={codes.includes(rackcode) ? rackcode : null}
                onChange={(_, newValue) => onFieldChange(index, { rackcode: newValue || "" })}
                renderInput={(params) => (
                  <TextField {...params} label="Rack Code" error={hasError("rackcode")} />
                )}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            {colours.length > 0 && (
              <Autocomplete
                options={colours}
                value={colours.includes(rackcolour) ? rackcolour : null}
                onChange={(_, newValue) => onFieldChange(index, { rackcolour: newValue || "" })}
                renderInput={(params) => (
                  <TextField {...params} label="Rack Colour" error={hasError("rackcolour")} />
                )}
              />
            )}
          </Grid>
        </Grid>
      )}

      {/* Row 3: Size */}
      {racktype && sizes.length > 0 && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={sizes}
              value={sizes.includes(racksize) ? racksize : null}
              onChange={(_, newValue) => onFieldChange(index, { racksize: newValue || "" })}
              renderInput={(params) => (
                <TextField {...params} label="Rack Size" error={hasError("racksize")} />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} />
        </Grid>
      )}
    </>
  );
}
